import styled from 'styled-components'
import { GREY_200 } from '../../utils/colors'

const H4 = styled.h4`
  font-family: Mont, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 112%;

  span {
    color: ${GREY_200};
    font-weight: 500;
  }
`

export default H4
